import { Component, OnDestroy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { DefaultMira } from '@irohalab/mira-sdk-angular';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, filter, switchMap } from 'rxjs/operators';


@Component({
    selector: 'app-search',
    imports: [FormsModule],
    templateUrl: './search.component.html',
    styleUrl: './search.component.less'
})
export class SearchComponent implements OnDestroy {
  keyword: string = '';
  suggestions: string[] = [];
  private searchSubject = new Subject<string>();
  private subscription = new Subscription();

  constructor(private router: Router, private miraService: DefaultMira) {
    this.subscription.add(
      this.searchSubject.pipe(
        filter(text => text.length > 2),
        debounceTime(300),
        switchMap(text => {
            return this.miraService.predictMainItemName(text);
        })
      ).subscribe((results: string[]) => {
        this.suggestions = results || [];
      })
    );
  }

  onKeywordChange(text: string) {
    this.searchSubject.next(text);
    if (text.length <= 2) {
        this.suggestions = [];
    }
  }

  onSelectSuggestion(s: string) {
    this.keyword = s;
    this.onSearch();
  }

  onSearch() {
    if (this.keyword) {
      this.suggestions = [];
      this.router.navigate(['/search'], { queryParams: { search_query: this.keyword } });
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
